import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  success: false,
  error: false,
  favorites: [],
  favoritesCount: 0,
  numberOfPages: 0,
  loadMoreFavorites: false,
  favStatus: null,
  favoriteLoading: false
};

const favoritesSlice = createSlice({
  name: "favorites",
  initialState,
  reducers: {
    getFavoritesStart: (state, action) => {
      state.loading = true;
      if (action.payload.initialCall) {
        state.favoriteLoading = true;
      }
      // }
    },
    getFavoritesSuccess: (state, action) => {
      if (
        action.payload.favoritePage !== 1 &&
        action.payload.favoritePage <= state.numberOfPages
      ) {
        state.loading = false;
        state.favorites = [...state.favorites, ...action.payload.favorites];
      }
      if (action.payload?.searchGames) {
        state.favorites = action.payload.favorites || [];
      }
      if (action.payload.favoritePage === 1) {
        state.loading = false;
        state.favorites = [...action.payload.favorites];
      }
      state.favoriteLoading = false;
      state.success = true;
      state.numberOfPages = action.payload?.numberOfPages || 0;
      state.favoritesCount = action.payload?.favoritesCount || 0;
    },
    getFavoritesFailure: (state) => {
      state.loading = false;
      state.error = true;
      state.loadMoreFavorites = false;
      state.favoriteLoading = false;
    },
    addRemoveFavoritesStart: (state, action) => {
      if (!action.payload?.notShowLoading) {
        state.loading = true;
      }
    },
    addRemoveFavoritesSuccess: (state, action) => {
      state.success = true;
      state.error = false;
      state.loading = false;
      state.favStatus = action.payload;
    },
    addRemoveFavoritesFailure: (state) => {
      state.error = true;
      state.success = false;
      state.loading = false;
    },
    resetSuccess: (state) => {
      state.success = initialState.success;
      state.favStatus = initialState.favStatus;
    },
    resetFavoritesState: () => initialState
  }
});

export const {
  getFavoritesStart,
  getFavoritesSuccess,
  getFavoritesFailure,
  addRemoveFavoritesStart,
  addRemoveFavoritesSuccess,
  addRemoveFavoritesFailure,
  resetSuccess,
  resetFavoritesState
} = favoritesSlice.actions;

export default favoritesSlice.reducer;
